import N8nInputNumber from './InputNumber.vue';

export default N8nInputNumber;
